import React, { useEffect, useState } from 'react';
//Components
import NuevaCatego from './NuevaCatego';
import NuevaFalla from './NuevaFalla';
//Context
import { FallasProvider, useFallas } from './FallasContext';
//Material-UI
import { DataGrid, esES } from '@material-ui/data-grid';
import { Chip, Snackbar } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
//Icons
import { Check } from 'tabler-icons-react';
//Styles
import '../../styles/fallas.css';
import '../../App.css';

const CHIP_PALETTE = [
    { bg: '#E7D4FF', color: '#3b0764' },
    { bg: '#AEE8FC', color: '#0c4a6e' },
    { bg: '#95FCDE', color: '#064e3b' },
    { bg: '#f8eab7', color: '#78350f' },
    { bg: '#FFAED2', color: '#831843' },
    { bg: '#FCCACD', color: '#7f1d1d' },
    { bg: '#fca63a', color: '#431407' },
    { bg: '#DBE0EA', color: '#1e293b' },
];

function makeCategoChip(bg, color) {
    return withStyles({
        root: { backgroundColor: bg, color, fontSize: '0.8125rem', fontWeight: 500 },
        clickable: {},
    })((props) => <Chip size="small" color="default" {...props} />);
}

function CategoChip({ index, label }) {
    const palette = CHIP_PALETTE[index % CHIP_PALETTE.length];
    const StyledChip = makeCategoChip(palette.bg, palette.color);
    return <StyledChip label={label} />;
}

function Fallas() {
    const {
        catego,
        fallas,
        handleDataSelect,
        getAreasAndFallas,
        getCatego,
        snackbar,
        setSnackbar,
        snackbarText,
    } = useFallas();

    const [selectionModel, setSelectionModel] = useState([]);

    const categoColumns = [
        {
            field: 'nombre',
            headerName: 'Nombre',
            flex: 1,
            minWidth: 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const idx = catego.findIndex((c) => c.id === params.row.id);
                return <CategoChip index={idx >= 0 ? idx : 0} label={params.value} />;
            },
        },
    ];

    const fallasColumns = [
        {
            field: 'areaNombre',
            headerName: 'Área',
            flex: 0.8,
            minWidth: 100,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'idCategoria',
            headerName: 'Categoría',
            flex: 1,
            minWidth: 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const idx = catego.findIndex((c) => c.categoria === params.value);
                const cat = idx >= 0 ? catego[idx] : null;
                if (!cat) return params.value ?? '—';
                return <CategoChip index={idx} label={cat.nombre} />;
            },
        },
        {
            field: 'nombre',
            headerName: 'Nombre de la falla',
            flex: 1.5,
            minWidth: 160,
            align: 'center',
            headerAlign: 'center',
        },
    ];

    const handleCloseSnackbar = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(false);
    };

    useEffect(() => {
        getCatego();
        getAreasAndFallas();
    }, [getAreasAndFallas, getCatego]);

    return (
        <div className="fallas-page">
            <Snackbar
                open={snackbar}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className="app-notif app-notif--success">
                    <Check size={20} strokeWidth={2} color="#fff" />
                    <span className="app-notif__msg">{snackbarText}</span>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>

            <div className="fallas-header">
                <div className="fallas-header-left">
                    <h1 className="titulo">Fallas</h1>
                    <p className="desc">Administrar fallas y sus categorías</p>
                </div>
            </div>

            <div className="fallas-body">
                {/* ── Panel Categorías ── */}
                <div className="fallas-panel-catego">
                    <div className="fallas-card">
                        <div className="fallas-card-toolbar">
                            <h2 className="fallas-card-title">Categorías</h2>
                            <NuevaCatego />
                        </div>
                        <div className="fallas-table-wrapper">
                            <DataGrid
                                checkboxSelection
                                columns={categoColumns}
                                rows={catego}
                                localeText={esES.props.MuiDataGrid.localeText}
                                disableColumnFilter
                                disableColumnMenu
                                disableColumnSelector
                                hideFooter
                                selectionModel={selectionModel}
                                onSelectionModelChange={(model) => {
                                    setSelectionModel(model);
                                    handleDataSelect(model);
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* ── Panel Fallas ── */}
                <div className="fallas-panel-fallas">
                    <div className="fallas-card">
                        <div className="fallas-card-toolbar">
                            <h2 className="fallas-card-title">Fallas</h2>
                            <NuevaFalla />
                        </div>
                        <div className="fallas-table-wrapper">
                            <DataGrid
                                columns={fallasColumns}
                                rows={fallas}
                                localeText={esES.props.MuiDataGrid.localeText}
                                disableColumnFilter
                                disableColumnMenu
                                disableColumnSelector
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const FallasWrapper = () => (
    <FallasProvider>
        <Fallas />
    </FallasProvider>
);

export default FallasWrapper;
